import * as React from 'react';

const Capacity = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={18} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1336-1089H584v8701h-1920z" />
            <g fillRule="nonzero" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
                <circle cx={7.5} cy={4.875} r={4.125} />
                <path d="M.75 17.25a6.75 6.75 0 1 1 13.5 0m.001-15.834a4.125 4.125 0 1 1-.006 6.914M15 10.667a6.757 6.757 0 0 1 8.25 6.583" />
            </g>
        </g>
    </svg>
);
export default Capacity;
